<div class="topbar">

  <div class="topbar-left">
    @if (!isSmallerScreen) {
      <button mat-icon-button (click)="toggleSidebar.emit()" class="hamburger">
        <mat-icon>menu</mat-icon>
      </button>
    }

    <img src="zignflix_logo_text.svg" alt="Application Name" class="logo-text sidebar-logo-text">

  </div>

  <div class="topbar-right">
    <!-- Updagrade Button -->
    @if ((currentSubscription.status === 'trial' && !isSubscriptionLoading) || getRemainingSubscriptionMinutes()<=4320) {
      <div class="trial-wrapper text-primary-color"
        >
        @if (currentSubscription.status === 'trial') {
          <span class="hide-on-small hide-on-medium">{{
          getRemainingTrialDays() }}</span>
        }
        @if (currentSubscription.status !== 'trial') {
          <span class="hide-on-small hide-on-medium"> {{
          getRemainingSubscriptionDisplay()}}</span>
        }
        <button mat-flat-button class="upgrade-button" (click)="openSubscriptionPopup()"
          (keydown.enter)="openSubscriptionPopup()" (keydown.space)="openSubscriptionPopup()"
        tabindex="0">Upgrade</button>
      </div>
    }
    <!-- Circular Icon Buttons -->
    <!-- <button class="icon-btn" *ngIf="!isSmallerScreen">
    <img src="svg/help_icon.svg" alt="Help" />
  </button> -->
  <!-- <button class="icon-btn" *ngIf="!isSmallerScreen">
  <img src="svg/bell_icon.svg" alt="Notification" />
</button> -->
<!-- <button class="icon-btn">
<img src="svg/gear_icon.svg" alt="Settings" />
</button> -->

<!-- Profile Section -->
<!-- Profile Section -->
<div class="profile" tabindex="0" (click)="openProfileDialog()" (keydown.enter)="openProfileDialog()"
  (keydown.space)="openProfileDialog()">
  <app-avatar [name]="profileDetail.full_name" [imageUrl]="profileDetail.profile_image"></app-avatar>
  @if (profileDetail.full_name) {
    <span class="screen-header">
      @if (!isSmallerScreen) {
        <span>&nbsp;{{profileDetail.full_name}}</span>
      }
    </span>
  }
  <i class="icon-dropdown"></i>
</div>

@if (isSmallerScreen) {
  <button class="icon-btn" [matMenuTriggerFor]="pagesMenu">
    <img src="svg/menu_icon.svg" alt="Menu" height="16" width="16" />
  </button>
}
<mat-menu #pagesMenu="matMenu" xPosition="before">
  @for (link of list; track link) {
    @if (link.is_visible) {
      <button mat-menu-item [routerLink]="link.path" [routerLinkActive]="['is-active']">
        <span>{{ link.name}}</span>
      </button>
    }
  }
</mat-menu>
</div>

</div>

<div class="overlay" [class.show]="isChangePasswordPanelVisible" (click)="handleOutsideClick($event)"
(keyup.enter)="handleOutsideClick($event)" (keyup.space)="handleOutsideClick($event)" tabindex="0"></div>
<div class="side-nav-container" [class.show]="isChangePasswordPanelVisible">
  <!-- Place your components here -->
  @if (isChangePasswordPanelVisible) {
    <div>
      <app-change-password (closeEvent)="handleCloseEvent($event)"></app-change-password>
    </div>
  }
</div>

<div class="overlay" [class.show]="isEditProfilePanelVisible" (click)="handleOutsideClick($event)"
(keyup.enter)="handleOutsideClick($event)" (keyup.space)="handleOutsideClick($event)" tabindex="0"></div>
<div class="side-nav-container" [class.show]="isEditProfilePanelVisible">
  <!-- Place your components here -->
  @if (isEditProfilePanelVisible) {
    <div>
      <app-add-user [currentUser]="currentUser" [isUpdateUser]="true" [isProfileEdit]="true"
      (closeEvent)="handleCloseEvent($event)"></app-add-user>
    </div>
  }
</div>